import { z } from 'zod';
export const MandatorSchema = z.object({
    name: z.string(),
    street: z.string().optional(),
    house_number: z.string().optional(),
    zip: z.string().optional(),
    city: z.string().optional(),
    country: z.string().optional(),
});
